import React from 'react'
import axios from 'axios';
import * as IoIcons from 'react-icons/io';
import Swal from "sweetalert2";
import { eliminaPermisos } from '../../Services/Rest';
function EliminarPermisos(props) {
    const Eliminar = e => {
        e.preventDefault(e)
        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
            method: 'DELETE',
            url: eliminaPermisos+props.id,
            data: {
                
            }
        })
        .then((Response) => {
            console.log(Response.data)
            Swal.fire({
              title: "Eliminado",
              text: "Haga clic para continuar",
              icon: 'success',
          }).then(function () {
              window.location.reload("/");
          })
             
          
        }).catch((error) => {
            console.log(error)
            Swal.fire({
              title: "No se elimino",
              text: "Haga clic para continuar",
              icon: 'error',
          }).then(function () {
              window.location.reload("/");
          })
        })
    };
  return (
    <div>
            <button variant="contained" className='btn btn-danger' color="primary" onClick={Eliminar} >  <IoIcons.IoIosCloseCircle /> </button>


    </div>
  )
}

export default EliminarPermisos